import Crud from '../views/Landmark/Crud'
import Entity from '../views/Landmark/Add'

let routes = {
    path: '/users',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/landmarks/add',
            name: 'NewLandmark',
            component: Entity,
            meta: {
                pageTitle: 'Landmark',
                access_level: ['1', '2'],
                breadcrumb: [
                    {
                        text: 'List',
                        active: false,
                        to: '/landmarks',
                    },
                    {
                        text: 'Add',
                        active: true,

                    },
                ],
            },
        },
        {
            path: '/landmarks/edit/:id?',
            name: 'EditLandmark',
            component: Entity,
            meta: {
                pageTitle: 'Landmark',
                access_level: ['1', '2'],
                breadcrumb: [
                    {
                        text: 'List',
                        active: false,
                        to: '/landmarks',
                    },
                    {
                        text: 'Edit',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/landmarks',
            name: 'list-landmarks',
            component: Crud,
            meta: {
                pageTitle: 'Landmarks',
                access_level: ['1', '2'],
                breadcrumb: [
                    {
                        text: 'List',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
